// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalFloatLoader_modal__3b-1e"};